import { Type } from '../../../../general/modules/filter/dataModel';
import { SearchBreadcrumbsCell } from '../../search/components/BreadcrumbsCell';
import { Column, FMColumn } from '../model';

export const breadcrumbsCol: FMColumn<Type.NONE> = {
  key: Column.breadcrumbs,
  dataKey: Column.breadcrumbs,
  title: 'Containing folder',
  minWidth: 400,
  sortable: false,
  cellRenderer: SearchBreadcrumbsCell,
  className: 'ch-file-manager__cell_breadcrumbs',
  getter: () => null,
  toDisplayString: () => null,
};
